import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface SelectedSeason {
  id: string;
  boundaryId: string;
  crop: string;
  variety: string;
  sowingDate: string;
  harvestDate: string;
}

interface FieldsState {
  selectedField: string;
  selectedSeason: SelectedSeason;
  selectedSeasonsDates: string[];
  isVarda: boolean;
}

const initialState: FieldsState = {
  selectedField: '',
  selectedSeason: {
    id: '',
    boundaryId: '',
    crop: '',
    variety: '',
    sowingDate: '',
    harvestDate: '',
  },
  selectedSeasonsDates: [],
  isVarda: false,
};

export const fieldsSlice = createSlice({
  name: 'fields',
  initialState,
  reducers: {
    selectField: (state, { payload: { id } }: PayloadAction<{ id: string }>) => {
      state.selectedField = id;
      return state;
    },
    selectSeason: (state, { payload }: PayloadAction<SelectedSeason>) => {
      state.selectedSeason = payload;
      return state;
    },
    selectSeasonsDates: (state, { payload: { dates } }: PayloadAction<{ dates: string[] }>) => {
      state.selectedSeasonsDates = dates;
      return state;
    },
    resetSelectedSeason: (state) => {
      state.selectedSeason = {
        id: '',
        boundaryId: '',
        crop: '',
        variety: '',
        sowingDate: '',
        harvestDate: '',
      };
      return state;
    },
    selectTypeBoundaries: (state, { payload }: PayloadAction<boolean>) => {
      state.isVarda = payload;
      return state;
    },
  },
  extraReducers: () => {},
});

export const {
  selectField,
  selectSeason,
  selectSeasonsDates,
  resetSelectedSeason,
  selectTypeBoundaries,
} = fieldsSlice.actions;
